import { UserProfile } from "./UserProfile";

export enum Role {
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
  Vendor = 'Vendor',
  VendorAdmin = 'VendorAdmin',
  BrandAdmin = 'BrandAdmin',
  Marketing = 'Marketing',
  Sales = 'Sales',
  Finance = 'Finance',
  Fulfilment = 'Fulfilment'
};

export interface SHRole {
  id: number;
  name: string;
}

export default interface User {
  id?: string;
  email: string;
  administratorEmail: string;
  adminMailbox: string;
  customerMailbox: string;
  deadLetterMailbox: string;
  name: string;
  role: Role;
  vendorId: number;
  vendor?: string | null;
  created?: number;
  lastLogin?: number;
  userProfiles?: UserProfile[]
};

export const BRAND_ROLES = [
  'BrandAdmin', 'Marketing', 'Sales', 'Finance', 'Fulfilment'
];

export interface UserPreferences {
  id: number;
  userId: number;
  companyTableColumnOrder: any[];
  customerTableColumnOrder: any[];
};

export function isAdmin(user: User): boolean {
  return user !== null && user.role === Role.Admin;
};

export function isSuperAdmin(user: User): boolean {
  return user !== null && user.role === Role.SuperAdmin;
};

export function isVendor(user: User): boolean {
  return user !== null && (user.role === Role.Vendor || user.role === Role.VendorAdmin);
};

export function isVendorAdmin(user: User): boolean {
  return user !== null && user.role === Role.VendorAdmin;
};

export function isOfmpAdmin(user: User): boolean {
  return user !== null && (user.role === Role.Admin || user.role === Role.SuperAdmin);
};

export function userIsAllowed(user: User, allowedRoles: Role[]): boolean {
  return allowedRoles.includes(user.role);
}

export function isBrandAdmin(user: User): boolean {
  return user !== null && (user.role === Role.BrandAdmin);
}

export function isBrandLevelRoles(user: User): boolean {
  return user !== null && (BRAND_ROLES.includes(user.role));
}


export function isVendorOnly(user: User): boolean {
  return user !== null && user.role === Role.Vendor;
}

/**
 * Check if user has OFMP Admin role (Admin or SuperAdmin) in userProfile array
 * @param user - The user object
 * @returns True if user has Admin or SuperAdmin role in userProfile
 */
export function hasOfmpAdminProfile(user: User | null): boolean {
  if (!user) return false;
  return user.userProfiles?.some(profile =>
    profile.role?.name === Role.Admin || profile.role?.name === Role.SuperAdmin
  ) || false;
}

/**
 * Check if user has VendorAdmin role for a specific vendor in userProfile array
 * @param user - The user object
 * @param vendorId - The vendor ID to check
 * @returns True if user has VendorAdmin role for the specified vendor
 */
export function hasVendorAdminProfileForVendor(user: User | null, vendorId?: number): boolean {
  if (!user || !vendorId) return false;
  return user.userProfiles?.some(profile =>
    profile.role?.name === Role.VendorAdmin && profile.vendorId === vendorId
  ) || false;
}
